module.exports = __webpack_public_path__ + "static/media/001.a9d4c576.svg";